<template>
  <el-dialog
    :close-on-press-escape="false"
    custom-class="layout-dialog"
    title="不具合履歴"
    top="5vh"
    :visible.sync="dialogVisible"
    append-to-body
    width="70%"
    @close="dialogVisible = false"
  >
    <vab-table
      ref="table"
      :columns="columns"
      :has-pager="false"
      :custom-config="false"
      :table-data="tableDataList"
    />
  </el-dialog>
</template>

<script>
  import { defectReportHistory } from '@/api/rc/PWR02G06'
  export default {
    name: 'ErrorRecords',
    data() {
      return {
        reportId: null,
        defectId: null,
        enable: false,
        tableDataList: [],
        dialogVisible: false,
        columns: [
          {
            label: '不具合ID',
            'min-width': 120,
            prop: 'defectId',
          },
          {
            label: '場所',
            'min-width': 120,
            prop: 'defectIdModel.location',
          },
          {
            label: '不具合内容',
            'min-width': 120,
            prop: 'defectIdModel.defectContent',
          },
          {
            label: '初回報告日',
            'min-width': 120,
            prop: 'defectIdModel.firstReportDate',
          },
          {
            label: '点検結果',
            'min-width': 120,
            prop: 'inspectionStatus',
            formatter: (row, column, cellValue) => {
              return this.getEnumText(
                cellValue,
                this.$divisions.inspectionStatusEnum
              )
            },
          },
          {
            label: '登録日',
            'min-width': 120,
            prop: 'changeDate',
          },
        ],
      }
    },
    mounted() {},
    methods: {
      async getData(defectId, reportNo) {
        this.defectId = defectId
        this.dialogVisible = true
        this.tableDataList = []
        const loadingInstance = this.$baseColorfullLoading()
        try {
          const res = await defectReportHistory({
            defectId: defectId,
            reportNo: reportNo,
          })
          if (res) {
            this.tableDataList = res
          }
        } finally {
          loadingInstance.close()
        }
      },
    },
  }
</script>

<style lang="scss" scoped></style>
